import { format, isSameMonth } from "date-fns";
import firebase from "firebase/app";
import { useRouter } from "next/router";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { useI18NContext } from "@/features/common/components/i18n/I18NProvider";
import { AvatarWithFallback } from "@/features/user/components/avatar/AvatarWithFallBack";
import { PostDetailFragment } from "@/generated/generated-hooks";
import { getUserProfilePath } from "@/helpers/common/path";
import { getPublicConfig } from "@/helpers/getPublicConfig";

type PostBasicInformationProps = {
  post: PostDetailFragment;

  // avatarImgSrc: string;
  // name: string;
  // views: number;
  // date: number | Date | string;
  // accountName: string;
};

const config = getPublicConfig();

export const PostBasicInformation: React.FC<PostBasicInformationProps> = ({
  post,
}) => {
  const { views, writer, isPublished, publishAt, createdAt } = post;
  const { accountName, displayName } = writer;

  const router = useRouter();
  const { formatDistanceToNowStrictWithLocale, ready } = useI18NContext();

  const goToPublicProfileHandler = () => {
    if (!!accountName.trim()) router.push(getUserProfilePath(accountName));
  };

  const onClickAvatar = () => {
    firebase.analytics().logEvent(AnalyticsEventEnum.PostPageClickAvatar);
    goToPublicProfileHandler();
  };

  const onClickDisplayName = () => {
    firebase.analytics().logEvent(AnalyticsEventEnum.PostPageClickDisplayName);
    goToPublicProfileHandler();
  };
  const postDate = new Date(publishAt ?? createdAt);
  return (
    <div
      className="flex items-center"
      data-test-id="PostBasicInformation-container"
    >
      <div className="touchable" onClick={onClickAvatar}>
        <AvatarWithFallback
          accountName={accountName}
          displayName={displayName}
          avatarUrl={writer.avatar?.url}
          sizeClassName="avatar-60"
        />
      </div>
      <div className="flex flex-col px-4 min-w-0">
        <span
          className="text-xl text-gray-900  touchable truncate"
          onClick={onClickDisplayName}
        >
          {displayName}
        </span>

        <div className="flex space-x-4">
          {/* <span className="text-sm text-gray-400">
            {new Intl.NumberFormat().format(views)} {t("views")}
          </span>

          <span className="border-l border-solid border-gray-400" /> */}

          {ready && isPublished && (
            <span className="text-sm text-gray-400">
              {isSameMonth(postDate, new Date())
                ? formatDistanceToNowStrictWithLocale({
                    date: new Date(publishAt ?? createdAt),
                  })
                : format(postDate, "dd/MM/yyyy")}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
